module.exports = __webpack_public_path__ + "img/39.dc966be9.png";